export const RAILS_URL = import.meta.env.VITE_RAILS_URL;
export const API_URL = import.meta.env.VITE_RAILS_API_URL;
export const VUE_USER_URL = import.meta.env.VITE_VUE_USER_URL;
export const VUE_ADMIN_URL = import.meta.env.VITE_VUE_ADMIN_URL;
export const ENV = import.meta.env.VITE_ENV;
export const SALESFORCE_BASE_URL = import.meta.env.VITE_SALESFORCE_BASE_URL;
